import "./CurrentDealsKPI.css";

import { Dispatch, SetStateAction, useMemo } from "react";

import { SelectData } from "../../../../models";
import { Column, Row, Select } from "../../..";

type CurrentDealsDataType = { [key: string]: { value: number; colour: string } };

interface CurrentDealsKPIProps {
  selectedValue: string;
  setSelectedValue: Dispatch<SetStateAction<string>>;
  selectData: SelectData;
  data: CurrentDealsDataType | undefined;
}

export const CurrentDealsKPI = ({
  selectedValue,
  setSelectedValue,
  selectData,
  data,
}: CurrentDealsKPIProps): JSX.Element => {
  const totalDeals = useMemo(
    () => (data ? Object.values(data).reduce((acc, current) => acc + current.value, 0) : 0),
    [data]
  );
  return (
    <div className="CurrentDealsContainer">
      <Row spacingV="l" align="center">
        <Column span={8}>
          <p className="body01">Current deals</p>
        </Column>
        <Column span={4} hasNoPadding>
          <Select
            data={selectData}
            value={selectedValue}
            onChange={(value) => setSelectedValue(value)}
            corners="rounded"
            fontSize="body3"
            size="small"
          />
        </Column>
      </Row>
      {data ? (
        <>
          <Row spacingV="s">
            <Column span={12}>
              <p className="body3Light">{totalDeals} deals</p>
            </Column>
          </Row>
          <Row spacingV="sl">
            <Column span={12} hasNoPadding>
              <div className="CurrentDealsGraphContainer">
                {Object.entries(data).map(([key, value]) => (
                  <div
                    key={key}
                    className="CurrentDealsGraphItem"
                    style={{ backgroundColor: value.colour, width: `${(value.value / totalDeals) * 100}%` }}
                  />
                ))}
              </div>
            </Column>
          </Row>
          <Row className="KeyDataContainer">
            {Object.entries(data).map(([key, value]) => (
              <Column key={key} span={4} hasNoPadding>
                <div className="KeyData">
                  <div className="KeyColour" style={{ backgroundColor: value.colour }} />
                  <div className="KeyDataContent">
                    <p className="body2Light">{key}</p>
                    <p className="body01">{value.value}</p>
                  </div>
                </div>
              </Column>
            ))}
          </Row>
        </>
      ) : (
        <p className="body3Light NoData">No data available</p>
      )}
    </div>
  );
};
